const ExpenseModeEnum = {
    ClinicianReimbursement: 'clinician-reimbursement',
    CreditCard: 'cc',
    Payment: 'payment',
    Vault: 'vault',
};
export { ExpenseModeEnum };
